import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCeJGrd3riXSeaInLHg7djIXOZja8y1QFw",
  authDomain: "fir-auth-403d8.firebaseapp.com",
  projectId: "fir-auth-403d8",
  storageBucket: "fir-auth-403d8.appspot.com",
  messagingSenderId: "203451868286",
  appId: "1:203451868286:web:1971c1f3a0bfd1807c642f"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;